// decision tree: https://coda.io/d/Partnership-Biz-Dev_dNhJHrgPj1d/Email-Survey_susAO#_luMZs
export const SURVEY_ANSWER_YES = "yes";
export const SURVEY_ANSWER_NO = "no";
export const SURVEY_ANSWER_UNSURE = "unsure";

export const SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1 = "subscribe-the-nest-1"; // result 1 || scenario 1 & 2
export const SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT = "manifest-locate-old-account"; // result 2 || scenario 3, 4, 7
export const SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1 = "manifest-transfer-old-account-1"; // result 3|| scenario 5 , 6
export const SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2 = "manifest-transfer-old-account-2"; // scenario 8
export const SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2 = "subscribe-the-nest-2"; // scenario 9

export const surveyResultsArray = [
  SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1,
  SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT,
  SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1,
  SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2,
  SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2,
];

export const emailSurveyQuestions = {
  1: {
    question: "Have you left a job in the last 5-10 years?",
    mandatory: true,
    options: [
      {
        label: "Yes",
        value: SURVEY_ANSWER_YES,
      },
      {
        label: "No",
        value: SURVEY_ANSWER_NO,
      },
    ],
  },
  2: {
    question: "Did you have an employer sponsored retirement account with that job?",
    mandatory: {
      conditions: [
        {
          question: 1,
          options: [SURVEY_ANSWER_YES, undefined],
        },
      ],
    },
    options: [
      {
        label: "Yes",
        value: SURVEY_ANSWER_YES,
      },
      {
        label: "No",
        value: SURVEY_ANSWER_NO,
      },
      {
        label: "Unsure",
        value: SURVEY_ANSWER_UNSURE,
      },
    ],
  },
  3: {
    question: "Did you contribute to that retirement account?",
    mandatory: {
      conditions: [
        {
          question: 1,
          options: [SURVEY_ANSWER_YES, undefined],
        },
        {
          question: 2,
          options: [SURVEY_ANSWER_YES, SURVEY_ANSWER_UNSURE, undefined],
        },
      ],
    },
    options: [
      {
        label: "Yes",
        value: SURVEY_ANSWER_YES,
      },
      {
        label: "No",
        value: SURVEY_ANSWER_NO,
      },
      {
        label: "Unsure",
        value: SURVEY_ANSWER_UNSURE,
      },
    ],
  },
  4: {
    question: "Where is that money now?",
    mandatory: {
      conditions: [
        {
          question: 1,
          options: [SURVEY_ANSWER_YES, undefined],
        },
        {
          question: 2,
          options: [SURVEY_ANSWER_YES, undefined],
        },
        {
          question: 3,
          options: [SURVEY_ANSWER_YES, undefined, SURVEY_ANSWER_UNSURE],
        },
      ],
    },
    options: [
      {
        label: "In my current account",
        value: "current-account",
      },
      {
        label: "Still in my old account",
        value: "old-account",
      },
      {
        label: "Unsure",
        value: SURVEY_ANSWER_UNSURE,
      },
    ],
  },
} as const;
